import { FormikHelpers, FormikProps } from 'formik';
import { createContext } from 'react';
import { FormButtonThemeVariant, InputThemeVariant } from '.';

export type FormOnSubmit = (
    values: Record<string, unknown>,
    formikHelpers: FormikHelpers<Record<string, unknown>>,
) => Promise<unknown>;

interface Context {
    buttonThemeVariant: FormButtonThemeVariant;
    inputThemeVariant: InputThemeVariant;
    formRef: React.RefObject<FormikProps<Record<string, unknown>>>;
    items: any;
    initialValues: Record<string, unknown>;
    // setOnSubmit: React.Dispatch<React.SetStateAction<FormOnSubmit>>;
}

export const FormContext = createContext<Context>(undefined!);
